<template>
    <v-app light id="main-wrapper" style="min-height: 665px;">
        <div class="text-xs-center">
            <v-dialog
              v-model="showOnline"
              hide-overlay
              width="300"
            >
              <v-card
                color="grey darken-3"
                dark
              >
                <v-card-text>
                  No Connection Found <br>
                    Please check your network connection
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
        </div>

        <router-view></router-view>

         <the-footer style="margin-bottom:-44px" />
   <!--  <v-footer class="footer" style="margin-bottom:-44px">
           &#169; {{ new Date().getFullYear() }} Advenue. All rights reserved. Build:{{ new Date().getDate().toString().padStart(2, "0")}}{{new Date().getMonth().toString().padStart(2, "0")}}{{ new Date().getFullYear()}}-1
    </v-footer> -->

    </v-app>
</template>

<script>
import TheFooter from "@/components/TheFooter";
 import * as localforage from "localforage";
import { loginService } from '@/components/_service/Users.js';
const API_URL = process.env.API_URL || 'https://mobile.innity.com.my/apipost'
export default {
          components: {

          TheFooter,

       },
        props:['show', 'message'],
        data() {
            return {
                online:false,
                showOnline:false,
                showMessage: true,
                // refresh variables
                refreshing: false,
                registration: null,
                updateExists: false,
                subscription:null  ,
                userId:loginService.getSaleId(),
              //  isSalePrivilege:false

            };
        },

        methods: {
            hideMessage() {
                this.showMessage = false
            },
            showRefreshUI(e) {
                this.registration = e.detail
                this.forceSWupdate();
                this.updateExists = true

            },
            refreshApp() {
                this.updateExists = false
                if (!this.registration || !this.registration.waiting) return
                // send message to SW to skip the waiting and activate the new SW
                this.registration.waiting.postMessage('skipWaiting')
            },

            //  createPushNotification1() {
            //  //  console.log('[createPushNotification1] get active service worker registration');

            //    if(this.subscription){
            //       //  console.log('here');
            //         const req = new Request(`${API_URL}/send_notification.php`, {
            //         method: 'POST',
            //         body: JSON.stringify(
            //             {
            //               subscription: this.subscription,
            //               userId:this.userId,
            //               flightcount:0,
            //               camcount:0,
            //               }
            //             )
            //         });
            //         const response =  self.fetch(req);

            //    }else{
            //    // console.log("[createPushNotification1] null")
            //    }

            // },
            forceSWupdate () {
              if ('serviceWorker' in navigator) {
                navigator.serviceWorker.getRegistrations().then(function (registrations) {
                  for (let registration of registrations) {
                    registration.update()
                  }
                })
              }
            },
            askPermission() {
                return new Promise(function(resolve, reject) {

                  const permissionResult = Notification.requestPermission(function(result) {
                   //  console.log('result from permission question', result);

                     resolve(result);
                  });

                  if (permissionResult) {
                  // this.showNotification();
                    permissionResult.then(resolve, reject);
                  }
                })
                .then(function(permissionResult) {
                  if (permissionResult !== 'granted') {
                     // console.warn('We weren\'t granted permission.')
                   // throw new Error();
                  }
                });
             },
            ////
            // findSubscription1() {
            //    if ('serviceWorker' in navigator) {
            //       return navigator.serviceWorker.ready
            //       .then(registration => {
            //            console.log('[findSubscription] active subscription op'+ registration);
            //           // console.log(registration)
            //        //   this.serviceWorkerRegistation = swreg

            //           return registration.pushManager.getSubscription();
            //       })
            //    }
            //   //  console.log('[findSubscription] get active service worker registration');

            // },
            showNotification() {
              if ('serviceWorker' in navigator) {
                 if (Notification.permission === 'granted') {
                    navigator.serviceWorker.ready // returns a Promise, the active SW registration
                      .then(swreg => swreg.showNotification('Notifications granted', {
                          body: 'You will recieve notification',
                          icon: '/img/icons/pwa-192.png',
                          badge: '/img/icons/pwa-72.png',
                          vibrate: [300, 200, 300],
                          data: {
                            url:'https://m.advenueplatform.com'
                          },

                      }))
                }
              }
          },
           iOSVersion() {
              var match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/),
                  version;

              if (match !== undefined && match !== null) {
                  version = [
                      parseInt(match[1], 10),
                      parseInt(match[2], 10),
                      parseInt(match[3] || 0, 10)
                  ];
                  return parseFloat(version.join('.'));
              }
              return false;
          },


        },
        beforeCreate(){

           // if ('serviceWorker' in navigator && 'PushManager' in window) {
           //    if (Notification.permission === 'granted') {

           //      let start = Date.now();
           //      let times = [];

           //      setTimeout(function () {
           //         times.push(Date.now() - start);
           //        if (start + 100 < Date.now()) {
           //              if (this.subscription != null && this.$store.state.isSalePrivilege.approve_flight_request) {

           //                console.log("send_notification ::" + this.$store.state.isSalePrivilege.approve_flight_request);
           //                this.createPushNotification1()
           //              }else{
           //                console.log("dont send_notification")
           //              }

           //        }else{

           //           setTimeout(run); // else re-schedule
           //        }


           //      }.bind(this), 1000)

           //  }


           // }
        },
        created() {

            document.addEventListener('swUpdated', this.showRefreshUI, {once: true})

            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (this.refreshing) return

              //  this.refreshApp()
                // Here the actual reload of the page occurs
                window.location.reload()
                this.refreshing = true
            })

          //  document.addEventListener('swUpdated', this.showRefreshUI, {once: true})
            document.addEventListener('swOffline', this.offlineApp, {once: true})
          //  console.log('swOffline')
            navigator.serviceWorker.addEventListener('controllerchange', () => {
               //  console.log("controllerchange") ;

              // Listen for changes in the state of our ServiceWorker
              navigator.serviceWorker.controller.addEventListener('statechange', function() {
               // console.log('[controllerchange][statechange] ' +
                 //       'A "statechange" has occured: ', this.state
                   //   );
                // If the ServiceWorker becomes "activated", let the user know they can go offline!
                if (this.state === 'activated') {
                    // Show the "You may now use offline" notification
                    this.online = false
                    this.showOnline =true
                  //
                }
              });
                // if (this.refreshing) return
                // this.refreshing = true
                // // Here the actual reload of the page occurs
                // window.location.reload()
            })
            // add "is-offline" class to the html element if user is offline and remove when online again
            window.addEventListener('load', function() {
                    function updateOnlineStatus(event) {
                        if (navigator.online) {
                           this.online=true
                           console.log('online')
                        } else {
                            this.online = false
                            this.showOnline =true

                          // console.log('offline')
                        }
                    }
                    window.addEventListener('online',  updateOnlineStatus);
                    window.addEventListener('offline', updateOnlineStatus);
            });

        },
        updated(){


        },
        mounted () {


          // if (window.location.protocol == 'http:') {

          //     console.log("you are accessing us via "
          //         +  "an insecure protocol (HTTP). "
          //         + "Redirecting you to HTTPS.");

          //     window.location.href =
          //         window.location.href.replace(
          //                    'http:', 'https:');

          // }
          // else if
          //     (window.location.protocol == "https:") {
          //         console.log("you are accessing us via"
          //             + " our secure HTTPS protocol.");
          //     }

          //  console.log(this.uss())
       //const wait = ms => new Promise(resolve => setTimeout(resolve, ms));


 //console.log(getDefinitions )
          //console.log(this.userId)
          let isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
          !window.MSStream;
          //console.log(isIOS)
          if (isIOS){
            //console.log(this.iOSVersion() );
            if (this.iOSVersion() < 11){
                 this.$router.push({ path: `/setting` })
              }

          }
        //

        // if(window.navigator.userAgent.match( /iP(hone|od|ad)/)){

        //         var iphone_version= parseFloat(String(window.navigator.userAgent.match(/[0-9]_[0-9]/)).split('_')[0]+'.'+String(window.navigator.userAgent.match(/[0-9]_[0-9]/)).split('_')[1]);

        //         // iPhone CPU iPhone OS 8_4 like Mac OS X

        //         console.log(iphone_version); // its alert 8.4

        //         if(iphone_version >= 12){
        //            console.log('iPhone device, iOS 12 version or greater!');
        //         }
        // }

          if (!('Notification' in window)) {
             console.log("This browser does not support notifications.");
          } else {
             // navigator.serviceWorker.register('/node_modules/localforage/dist/localforage.min.js');
              this.askPermission();

          }

        // console.log(this.findSubscription1())
            // this.findSubscription1()
            // .then(sub => {
            //    console.log(sub)
            //     if (sub === null) {
            //         console.log('[mounted updated] no active subscription found on the client');
            //        // this.buttonDisabled = false
            //        // this.notificationsEnabled = false
            //     } else {
            //        // console.log('[mounted updated] Active subscription found', sub);
            //         // retrieve user info from API
            //      //   this.buttonDisabled = false
            //     //    this.notificationsEnabled = true
            //         this.subscription = sub

            //     }
            //  })
            // if (navigator.serviceWorker.controller) {
            //   // A ServiceWorker controls the site on load and therefor can handle offline
            //   // fallbacks.
            //   console.log('DEBUG: serviceWorker.controller is truthy');
            //     console.debug(navigator.serviceWorker.controller.scriptURL + ' (onload)', 'controller');
            // }

            // else {
              // Register the ServiceWorker
           //   console.log('DEBUG: serviceWorker.controller is falsy');
              // navigator.serviceWorker.register('service-worker.js', {
              //   scope: './'
              // }).then(function(reg) {
              //   console.debug(reg.scope, 'register');
              // });https://github.com/justmarkup/demos/blob/gh-pages/indicating-offline/index.html
            //}

            // messaging.onTokenRefresh(() => {
            //   messaging.getToken().then((refreshedToken) => {
            //     console.log('Token refreshed.');
            //     // Indicate that the new Instance ID token has not yet been sent to the
            //     // app server.
            //     setTokenSentToServer(false);
            //     // Send Instance ID token to app server.
            //     sendTokenToServer(refreshedToken);
            //     // ...
            //   }).catch((err) => {
            //     console.log('Unable to retrieve refreshed token ', err);
            //     showToken('Unable to retrieve refreshed token ', err);
            //   });
            // });

          this.online = navigator.online
          window.addEventListener('online',()=>{
            this.online=true
          })
          window.addEventListener('offline',()=>{
            this.online = false
            this.showOnline =true
          })
        },
        watch: {
            dialog (val) {
                if (!val) return

                setTimeout(() => (this.showOnline = false), 4000)
              }
            }
    };
</script>
<style scoped>

</style>
